import "./login.css"
import { AuthContext } from "../../context/AuthContext";
import { useContext, useRef } from "react";
import {CircularProgress} from "@mui/material"
import { loginCall } from "../../apiCalls";

export default function Login() {
  const userLogin = useRef();
  const userPassword = useRef();
  const {user, isFetching, error, dispatch} = useContext(AuthContext);

  const handleClick = (e)=>{
    e.preventDefault();
    loginCall({userlogin:userLogin.current.value, password:userPassword.current.value}, dispatch);
  }

  return (
    <div className="login">
      <div className="loginWrapper">
        <div className="loginLeft">
          <h3 className="loginLogo">FDT</h3>
          <span className="loginDesc">
            <b>F</b>lächenlagen <b>D</b>isponierungs-<b>T</b>ool für den Landkreis Leer
          </span>
        </div>
        <div className="loginRight">
          <form className="loginBox" onSubmit={handleClick}>
            <input
              placeholder="Benutzername"
              type="text"
              required
              className="loginInput"
              ref={userLogin}
          />
            <input
              placeholder="Kennwort"
              type="password"
              required
              minLength="6"
              className="loginInput"
              ref={userPassword}
            />
            <button className="loginButton" 
              type="submit" 
              color="textPrimary">{isFetching ? <CircularProgress color="white"/> : "Anmelden"}
            </button>
          </form>
        </div>
      </div>
    </div>
    )
}
